import { sectionRenderer } from '@theme/section-renderer';

let active;
let sequence = 0;
let debounceTimer;
const snapshots = new Map();
const sectionFor = () => document.querySelector('results-list[data-rudo-default-sort]')?.closest('.shopify-section');
const remember = () => {
  const section = sectionFor();
  if (section) snapshots.set(location.href, { html: section.innerHTML, y: scrollY });
  if (snapshots.size > 8) snapshots.delete(snapshots.keys().next().value);
};

export async function navigateCatalog(sectionId, url, mode = 'push') {
  url = new URL(url, location.origin);
  url.searchParams.delete('section_id');
  clearTimeout(debounceTimer);
  active?.abort();
  active = new AbortController();
  const controller = active;
  const id = ++sequence;
  const section = document.getElementById(`shopify-section-${sectionId}`);
  if (!section) return;
  const list = section.querySelector('results-list');
  const requestUrl = new URL(url);
  if (list?.dataset.rudoExactQuery && requestUrl.searchParams.get('q') === list.dataset.rudoSearchQuery) {
    requestUrl.searchParams.set('q', list.dataset.rudoExactQuery);
  }
  list?.cancelPagination?.();
  list?.setAttribute('aria-busy', 'true');
  const open = [...section.querySelectorAll('details[open]')].map(e => e.querySelector(':scope > summary')?.getAttribute('aria-controls')).filter(Boolean);
  const focus = document.activeElement?.id;
  const status = section.querySelector('[data-rudo-filter-status]');
  if (status) status.textContent = 'Actualizando productos…';
  if (mode !== 'pop') remember();
  try {
    const cached = mode === 'pop' ? snapshots.get(url.toString()) : null;
    const html = cached?.html || await sectionRenderer.getSectionHTML(sectionId, false, requestUrl, controller.signal);
    if (controller.signal.aborted || id !== sequence) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = cached ? parsed.body : parsed.getElementById(`shopify-section-${sectionId}`);
    if (!replacement?.querySelector('results-list')) throw new Error('catalog_invalid_response');
    if (mode !== 'pop') history[mode === 'replace' ? 'replaceState' : 'pushState']({ rudoCatalog: true }, '', url);
    section.replaceChildren(...replacement.childNodes);
    initializeControls(section);
    for (const details of section.querySelectorAll('details')) {
      const controls = details.querySelector(':scope > summary')?.getAttribute('aria-controls');
      if (controls) details.open = open.includes(controls);
    }
    if (focus) document.getElementById(focus)?.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('rudo:section-rendered', { detail: { sectionId } }));
    const newStatus = section.querySelector('[data-rudo-filter-status]');
    if (newStatus) newStatus.textContent = 'Productos actualizados.';
    if (cached) requestAnimationFrame(() => scrollTo(0, cached.y));
  } catch (error) {
    if (controller.signal.aborted || id !== sequence) return;
    if (status) {
      status.replaceChildren(document.createTextNode('No se pudo actualizar. Tus productos siguen aquí. '));
      const retry = document.createElement('button');
      retry.type = 'button'; retry.textContent = 'Reintentar';
      retry.addEventListener('click', () => navigateCatalog(sectionId, url, mode), { once: true });
      const fallback = document.createElement('a');
      fallback.href = url.toString(); fallback.textContent = 'Abrir resultados';
      status.append(retry, document.createTextNode(' '), fallback);
    }
  } finally {
    if (id === sequence) { section.querySelector('results-list')?.setAttribute('aria-busy', 'false'); active = null; }
  }
}

function formURL(form) {
  const url = new URL(location.href);
  for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') url.searchParams.delete(key);
  for (const [key, value] of new FormData(form)) if (String(value).trim()) url.searchParams.append(key, value);
  return url;
}

function apply(form) {
  if (!form.checkValidity()) return;
  const min = form.elements.namedItem('filter.v.price.gte');
  const max = form.elements.namedItem('filter.v.price.lte');
  if (min?.value && max?.value && Number(min.value) > Number(max.value)) return;
  const id = form.closest('.shopify-section').id.replace('shopify-section-', '');
  navigateCatalog(id, formURL(form));
}

function initializeControls(scope = document) {
  for (const form of scope.querySelectorAll('[data-rudo-collection-tools]:not([data-rudo-tools-ready])')) {
    form.dataset.rudoToolsReady = 'true';
    form.querySelectorAll('[data-rudo-filter-drawer]').forEach(d => { d.open = innerWidth > 700 || d.dataset.rudoActiveFilterCount !== '0'; });
    form.querySelector('button[type="submit"]')?.setAttribute('hidden', '');
  }
  for (const link of scope.querySelectorAll('a[href*="/collections/"]')) {
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && !url.searchParams.has('sort_by')) { url.searchParams.set('sort_by', 'price-descending'); link.href = url; }
  }
}

document.addEventListener('input', event => {
  const form = event.target.closest('[data-rudo-collection-tools]');
  if (!form) return;
  active?.abort(); sectionFor()?.querySelector('results-list')?.cancelPagination?.();
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => apply(form), event.target.type === 'number' ? 600 : 350);
});
document.addEventListener('change', event => {
  const form = event.target.closest('[data-rudo-collection-tools]');
  if (!form) return;
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => apply(form), event.target.type === 'number' ? 0 : 350);
});
document.addEventListener('submit', event => {
  if (event.target.matches('[data-rudo-collection-tools]')) { event.preventDefault(); apply(event.target); }
});
document.addEventListener('click', event => {
  const link = event.target.closest('.rudo-active-filters a, .rudo-collection-controls__clear');
  if (link && !event.ctrlKey && !event.metaKey) {
    event.preventDefault();
    const url = new URL(link.href);
    for (const [key,value] of new URL(location.href).searchParams) if (!key.startsWith('filter.') && key !== 'page' && !url.searchParams.has(key)) url.searchParams.append(key,value);
    navigateCatalog(link.closest('.shopify-section').id.replace('shopify-section-', ''), url);
  }
  if (event.target.closest('results-list a[href*="/products/"]')) {
    const section = sectionFor();
    try { sessionStorage.setItem('rudo:catalog-return', JSON.stringify({ url: location.href, html: section.innerHTML, y: scrollY, at: Date.now() })); } catch {}
  }
});
document.addEventListener('toggle', event => {
  if (!event.target.closest?.('[data-rudo-collection-tools]')) return;
  const summary = event.target.querySelector(':scope > summary');
  summary?.setAttribute('aria-expanded', String(event.target.open));
}, true);
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const details = event.target.closest('[data-rudo-menu][open], [data-rudo-filter-drawer][open]');
  if (details) { details.open = false; details.querySelector('summary')?.focus(); }
});
window.addEventListener('popstate', () => {
  const section = sectionFor();
  if (section) navigateCatalog(section.id.replace('shopify-section-', ''), location.href, 'pop');
});

function init() {
  initializeControls();
  const list = document.querySelector('results-list[data-rudo-default-sort]');
  if (!list) return;
  const url = new URL(location.href);
  const sorts = JSON.parse(list.dataset.rudoValidSorts || '[]');
  if (url.searchParams.getAll('sort_by').length !== 1 || !sorts.includes(url.searchParams.get('sort_by'))) {
    url.searchParams.set('sort_by', list.dataset.rudoDefaultSort);
    navigateCatalog(list.getAttribute('section-id'), url, 'replace');
    return;
  }
  if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
    try {
      const snapshot = JSON.parse(sessionStorage.getItem('rudo:catalog-return') || 'null');
      if (snapshot?.url === location.href && Date.now() - snapshot.at < 300000) {
        snapshots.set(snapshot.url, snapshot);
        navigateCatalog(list.getAttribute('section-id'), url, 'pop');
      }
    } catch {}
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
